var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "json-forms-section" }, [
    _vm.editJSON
      ? _c("textarea", {
          staticStyle: { width: "100%" },
          attrs: { rows: "16" },
          domProps: { value: _vm.asString },
          on: { change: _vm.onStringChange },
        })
      : _c(
          "div",
          [
            _c("json-forms", {
              attrs: {
                data: _vm.valueOrDefault,
                schema: _vm.options.json_schema,
                uischema: _vm.options.json_edit_layout,
                renderers: _vm.renderers,
              },
              on: { change: _vm.onChange },
            }),
          ],
          1
        ),
    _vm._v(" "),
    _c("div", { staticClass: "text-right" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-link btn-sm",
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.toggleEditJSON.apply(null, arguments)
            },
          },
        },
        [_vm._v("\n            " + _vm._s(_vm.toggleLabel) + "\n        ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }